import { useState } from "react";
import NewsList from "../../components/news/NewsList";
import FilterNews from "./components/filterNews/FilterNews";

const NewsContainer = () => {
  const [activeTab, setActiveTab] = useState<string>("allNews");

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
  };

  return (
    <div className="w-screen max-w-[1000px] px-5 pt-9 bg-white md:max-w-[1000px] md:px-0">
      <h1 className="pb-5  text-2xl font-bold">Новини</h1>
      <div>
        <FilterNews activeTab={activeTab} handleTabChange={handleTabChange} />
      </div>

      <div className="w-full md:flex md:justify-between md:flex-wrap pt-2">
        <NewsList activeTab={activeTab} />
      </div>
    </div>
  );
};

export default NewsContainer;
